import smoothscroll from "smoothscroll-polyfill";

export default () => {
	const accordions = document.querySelectorAll(".accordion__wrap");

	if (!accordions) return;

	smoothscroll.polyfill();

	for (const accordion of accordions) {
		const panels = accordion.querySelectorAll(".accordion__item");
		for (const panel of panels) {
			const head = panel.querySelector(".accordion__title"),
				content = panel.querySelector(".accordion__content");
			head.addEventListener("click", e => {
				for (const otherPanel of panels) {
					if (otherPanel !== panel) {
						otherPanel.classList.remove("active");
						otherPanel.querySelector(".accordion__content").style.height = "";
					}
				}
				if (panel.classList.contains("active")) {
					panel.classList.remove("active");
					content.style.height = "";
				} else {
					let contentHeight = content.scrollHeight;
					panel.classList.add("active");
					content.style.height = contentHeight + "px";

					setTimeout(function() {
						let top = e.target.offsetTop;
						window.scroll({ top: top - 200, left: 0, behavior: "smooth" });
					}, 200);
				}
			});

			window.addEventListener("resize", () => {
				if (panel.classList.contains("active")) {
					content.style.height = "auto";
					setTimeout(
						() => (content.style.height = content.scrollHeight + "px"),
						1000
					);
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./scripts/modules/accordion.js